import flight from 'flightjs';
import $ from 'jquery';
import debounce from 'lodash.debounce';

function layoutButton() {
    const MAX_ZOOM = 3;
    const MIN_ZOOM = 1;

    this.imageLoadPromise = $.Deferred();

    this.attributes({
        image: '[data-entry-image]',
        expandButton: '[data-image-expand]',
    });

    this.getOriginalImageDimensions = function() {
        const image = this.select('image');
        return {
            width: parseInt(image[0].naturalWidth, 10),
            height: parseInt(image[0].naturalHeight, 10),
        };
    };

    this.canZoomOut = function() {
        const image = this.select('image');
        const zoom = this.getZoomLevel();
        const container = this.$node;

        const isImageLargerThanContainer =
            image.height() > container.height() || image.width() > container.width();

        return isImageLargerThanContainer && zoom > MIN_ZOOM;
    };

    this.canZoomIn = function() {
        const image = this.select('image');
        const zoom = this.getZoomLevel();
        const dimensions = this.getOriginalImageDimensions();

        const isImageSmallerThanOriginal =
            image.width() < dimensions.width || image.height() < dimensions.height;

        return isImageSmallerThanOriginal && zoom < MAX_ZOOM;
    };

    this.getZoomLevel = function() {
        return parseInt(this.$node.attr('data-zoom'), 10);
    };

    this.setZoomLevel = function(zoom) {
        this.$node.attr('data-zoom', zoom);
    };

    this.zoom = function(e, direction) {
        let zoom = this.getZoomLevel();

        if (this.canZoomIn() && direction > 0) {
            zoom += 1;
        }

        if (this.canZoomOut() && direction < 0) {
            zoom -= 1;
        }

        this.setZoomLevel(zoom);

        // Make sure we resize the image parent container
        // before recalculating if we can zoom in / zoom out.
        this.resizeImageParentContainer();
        this.trigger('uiImageZoomed', {
            canZoomOut: this.canZoomOut(),
            canZoomIn: this.canZoomIn(),
            zoom,
        });
    };

    this.resizeImageParentContainer = function() {
        const image = this.select('image');
        const parent = image.parent();
        const expandBtn = this.select('expandButton');

        parent.css({
            height: '100%',
            width: '100%',
        });

        const newHeight =
            expandBtn.css('display') !== 'none' && image.width() < image.height()
                ? image.width()
                : image.height();
        // Force reflow
        parent.offsetHeight; // eslint-disable-line no-unused-expressions

        parent.css({
            height: newHeight,
            width: image.width(),
        });

        if (expandBtn.css('display') !== 'none' && newHeight === image.height()) {
            expandBtn.css('display', 'none');
        }
    };

    this.resize = function() {
        this.imageLoadPromise.done(() => {
            this.resizeImageParentContainer();
            this.trigger('uiImageResized', {
                canZoomOut: this.canZoomOut(),
                canZoomIn: this.canZoomIn(),
            });
        });
    };

    this.expand = function() {
        this.setZoomLevel(2);

        this.select('expandButton').css('display', 'none');
        this.resizeImageParentContainer();
        this.trigger('uiImageZoomed', {
            canZoomOut: this.canZoomOut(),
            canZoomIn: this.canZoomIn(),
        });
    };

    this.updateExpandButton = function() {
        if (this.getZoomLevel() !== MAX_ZOOM) {
            this.select('expandButton').removeAttr('data-hidden');
        } else {
            this.select('expandButton').attr('data-hidden', true);
        }
    };

    this.setupPromise = function() {
        const $image = this.select('image');
        const promise = this.imageLoadPromise;

        // resolve promise on image load
        $image.load(() => {
            promise.resolve();
        });

        // if already loaded, resolve promise now
        $image.each((idx, image) => {
            if (image.complete) {
                promise.resolve();
            }
        });
    };

    this.after('initialize', function() {
        this.on('click', {
            expandButton: this.expand,
        });

        // Run after all other components are initialized
        window.setTimeout(this.setupPromise.bind(this), 0);

        this.on(document, 'uiImageZoomRequested', this.zoom);
        this.on('uiImageResized', this.updateExpandButton);

        this.resize();
        this.on(document, 'uiSidebarToggled', this.resize);
        this.on(document, 'uiImageModeChanged', this.resize);
        this.on(window, 'resize', debounce(this.resize.bind(this), 150));
    });
}

export default flight.component(layoutButton);



// WEBPACK FOOTER //
// ./src/js/component_ui/image.js